/// <reference path="../typings/index.d.ts" />
namespace App {
  export class TopSniperFernando {
    private ajax: any = null
    private urlUpdateFiltro: string = null
    private topCartasMomento: ICartaTopSniper[] = [];
    private keyStorageCartasArmazenadas: string = 'cartasArmazenadas';
    private keyStorageUltimaVezSalvoFiltroFull: string = 'ultimaVezSalvo';
    private intervaloEmMinutosStorageTempoAtualizacaoFiltroFull: number = 120; // 2 horas em minutos

    private configuracoes: {
      filtros: {
        id_filtro_especial_piloto_a: number,
        id_filtro_especial_piloto_b: number,
        id_filtro_especial_piloto_c: number,
        id_filtro_especial_piloto_d: number,
        id_filtro_piloto_inicial_A: number,
        id_filtro_piloto_inicial_B: number,
        id_filtro_piloto_inicial_C: number,
        id_filtro_piloto_full_A: number,
        id_filtro_piloto_full_B: number,
        id_filtro_piloto_top_filtros_A: number,
        id_filtro_piloto_top_filtros_B: number,
      },
      piloto: {
        full: {
          lucro_unitario_minimo: number
          lucro_unitario_minimo_cartas_relacionadas: number // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
          total_cartas_relacionadas_incluir_no_filtro: number
        },
        inicial: {
          raridade_minima_piloto_inicial: number
          valor_caixa_maximo: number
          preco_compra_carta_acima_de: number
          lucro_unitario_minimo: number,
          lucro_unitario_minimo_cartas_relacionadas: number // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
          total_cartas_relacionadas_incluir_no_filtro: number
        },
        principal: {
          raridade_minima_piloto_principal: number,
          lucro_unitario_minimo: number
          lucro_unitario_minimo_cartas_relacionadas: number // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
          valor_caixa_maximo: number
          preco_compra_carta_acima_de: number
          desconsiderar_poucas_cartas_acima_de: number
          quantidade_considero_poucas_cartas: number
          quantidade_indicativa_que_a_carta_esta_caindo: number
          total_cartas_relacionadas_incluir_no_filtro: number
        }
      },
      minimo_lucro_total_carta: number,
      usar_filtro_qualidade: boolean,
    } = null

    constructor(urlUpdateFiltro: string) {
      this.urlUpdateFiltro = urlUpdateFiltro
      this.configuracoes = {
        filtros: {
          id_filtro_especial_piloto_a: 50105,
          id_filtro_especial_piloto_b: 50311,
          id_filtro_especial_piloto_c: 50557,
          id_filtro_especial_piloto_d: 53982,
          id_filtro_piloto_inicial_A: 54949,
          id_filtro_piloto_inicial_B: 0,
          id_filtro_piloto_inicial_C: 0,
          id_filtro_piloto_full_A: 60313,
          id_filtro_piloto_full_B: 60548,

          id_filtro_piloto_top_filtros_A: 57554,
          id_filtro_piloto_top_filtros_B: 59226
        },
        piloto: {
          full: {
            lucro_unitario_minimo: 30000,
            lucro_unitario_minimo_cartas_relacionadas: 15000, // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
            total_cartas_relacionadas_incluir_no_filtro: 1
          },
          inicial: {
            raridade_minima_piloto_inicial: 1, // raridade minima de filtro das cartas para edição dos filtros do piloto inicial
            valor_caixa_maximo: 10000, // lucro minimo que a carta tem que dá para passar no filtro
            preco_compra_carta_acima_de: 700, // filtrar apenas cartas que são compradas acima desse valor
            lucro_unitario_minimo: 1000, // a carta tem que dá no minimo esse lucro para passar no filtro
            lucro_unitario_minimo_cartas_relacionadas: 1000, // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
            total_cartas_relacionadas_incluir_no_filtro: 1
          },
          principal: {
            raridade_minima_piloto_principal: 1, // raridade minima das cartas para passar no filtro
            lucro_unitario_minimo: 30000, // a carta tem que dá no minimo esse lucro para passar no filtro
            valor_caixa_maximo: 300000, // cria filtros com o caixa limite informado.
            preco_compra_carta_acima_de: 10000, // filtrar apenas cartas que são compradas acima desse valor
            desconsiderar_poucas_cartas_acima_de: 500000, // desconsidear cartas que tem poucas unidades e são compradas acima desse valor
            quantidade_considero_poucas_cartas: 1, // quantidade de cartas que considero poucas
            quantidade_indicativa_que_a_carta_esta_caindo: 1, // quantidade de cartas que indica que a carta está caindo no momento
            lucro_unitario_minimo_cartas_relacionadas: 10000, // para aquelas cartass de mesma raridade que quero colocar junto ao filtro da carta principal
            total_cartas_relacionadas_incluir_no_filtro: 0
          }
        },

        minimo_lucro_total_carta: 100000, // lucro geral obtido com a carta para poder entrar no topCartas
        usar_filtro_qualidade: false
      };
    }

    public async validarRegrasUrlCarregada(urlAtual: string): Promise<string> {
      return null
    }

    public iniciarRecarregamento() {
      window.location.href = 'https://futsniperweb.com.br/admin/top-sniper'
    }

    /**
   * Condição para as cartas certas que considero importantes está em minha análise
   * @param objTopCarta
   */
    public condicaoTopCartasImportantes(objTopCarta: ICartaTopSniper) {
      if (objTopCarta.lucro > this.configuracoes.minimo_lucro_total_carta) {
        this.topCartasMomento.push(objTopCarta)
      }
    }

    public async prepararTopCartas() {
      this.topCartasMomento = await Promise.all(this.topCartasMomento.map(async (item: ICartaTopSniper) => ({ ...item, player_info: await TopSniperUtil.filtrarPlayerInfoOrg(item.nome, item.resource_id) })));
      this.topCartasMomento.sort((a: any, b: any) => b.lucro - a.lucro);
      console.log('💸TOP_CARTAS_NANDO::', this.topCartasMomento);
      this.iniciandoAnaliseTopcartas();
      this.iniciandoAnaliseTopFiltros();
    }

    public static salvarFiltroFernando(id: number, cartaDoFiltro: ICartaTopSniper, todasCartasSelecionadas: ICartaTopSniper[], lucroMinimoUnitarioCartasRelacionadas: number, totalCartasRelacionadasJuntarNoFiltro: number, urlUpdateFiltro: string) {
      let valorCompraCarta = Util.getPrecoVariacaoMax(TopSniperUtil.getMenorPreco(cartaDoFiltro.valor_all, cartaDoFiltro.valor), TopSniperUtil.getIncrementoPrecoCompraFernando(cartaDoFiltro.valor))
      let idsCartasMesmaRaridades = [];

      if (totalCartasRelacionadasJuntarNoFiltro) {
        idsCartasMesmaRaridades = TopSniperUtil.filtrarCartarRelacionadasPorRaridade(cartaDoFiltro.asset_id, todasCartasSelecionadas, cartaDoFiltro.raridade.id, valorCompraCarta, lucroMinimoUnitarioCartasRelacionadas).map((item: any) => item.asset_id)
        // se idsCartasMesmaRaridades for maior que o totalCartasRelacionadasJuntarNoFiltro, então pego apenas o totalCartasRelacionadasJuntarNoFiltro
        if (idsCartasMesmaRaridades.length >= totalCartasRelacionadasJuntarNoFiltro) {
          idsCartasMesmaRaridades = idsCartasMesmaRaridades.slice(0, totalCartasRelacionadasJuntarNoFiltro)
        }

        // se existir idsCartasMesmaRaridades, então adiciono a carta principal cartaDoFiltro.asset_id junta a lista
        if (idsCartasMesmaRaridades.length) {
          idsCartasMesmaRaridades.push(cartaDoFiltro.asset_id)
        }
      }

      TopSniperUtil.salvarFiltroPiloto(urlUpdateFiltro, {
        id: id,
        variar: TopSniperUtil.getVariacaoFiltroFernando(cartaDoFiltro.valor),
        maxBuyNow: valorCompraCarta,
        maskedDefId: idsCartasMesmaRaridades.length ? idsCartasMesmaRaridades : [cartaDoFiltro.asset_id],
        rarity: [cartaDoFiltro.rareflag]
      });
    }

    public static salvarFiltroFernandoPorQualidade(id: number, cartaDoFiltro: ICartaTopSniper, todasCartasSelecionadas: ICartaTopSniper[], lucroMinimoUnitarioCartasRelacionadas: number, totalCartasRelacionadasJuntarNoFiltro: number, urlUpdateFiltro: string) {
      let valorCompraCarta = Util.getPrecoVariacaoMax(TopSniperUtil.getMenorPreco(cartaDoFiltro.valor_all, cartaDoFiltro.valor), TopSniperUtil.getIncrementoPrecoCompraFernando(cartaDoFiltro.valor))

      TopSniperUtil.salvarFiltroPiloto(urlUpdateFiltro, {
        id: id,
        variar: TopSniperUtil.getVariacaoFiltroFernando(cartaDoFiltro.valor),
        maxBuyNow: valorCompraCarta,
        maskedDefId: [cartaDoFiltro.asset_id],
        quality: "SP"
      });
    }

    private iniciandoAnaliseTopcartas() {
      // valor é o valor de compra
      // preco é o preço de venda
      // total é quantidade de cartas total encontrada
      // quantidade_mais é a quantidade de cartas encontrada a mais da ultima vez que filtrei
      // lucro_unitario é quanto de lucro a carta me dará apos ser vendida

      this.metodoTopCartasPilotoPrincipal()
      this.metodoTopCartasOuroPilotoSecundarioInicial()
    }


    private iniciandoAnaliseTopFiltros() {
      if (!this.ajax) {
        this.ajax = new Ajax();
      }

      console.log("URL APP", `${window.location.origin}/admin/top-filtros-json`)

      this.ajax.get(`${window.location.origin}/admin/top-filtros-json`, {}, (dadosSucesso: IRespostaSucessoAjx) => {
        this.tratarDadosTopFiltros(dadosSucesso.dadosRetornados && dadosSucesso.dadosRetornados.topFiltros ? dadosSucesso.dadosRetornados.topFiltros : [])
      }, null, null, false)
    }

    private tratarDadosTopFiltros(topFiltros: IObjetoTopFiltros[] = []): void {
      console.log("💸DADOS TOP FILTROS::", topFiltros);

      if (!topFiltros.length) {
        console.warn("Nenhum filtro encontrado.");
        return;
      }

      const melhoresFiltros = this.getMelhoresFiltrosDeMomento(topFiltros, 3, {
        minPriceFloor: 10000,
        minRangeAbs: 15000,
        suspiciousIds: new Set([])
      });

      console.log("💸MELHORES FILTROS DO MOMENTO::", melhoresFiltros);

      if (!melhoresFiltros.length) {
        console.warn("Nenhum filtro qualificado encontrado.");
        return;
      }

      // Salvar os melhores filtros (verifica se existem filtros suficientes)
      const filtrosPiloto = [
        { id: this.configuracoes.filtros.id_filtro_piloto_top_filtros_A, filtro: melhoresFiltros[0] || null },
        { id: this.configuracoes.filtros.id_filtro_piloto_top_filtros_B, filtro: melhoresFiltros[1] || null }
      ];


      filtrosPiloto.forEach((f) => {
        if (f.filtro) {
          console.log(`💸 Substituir filtro ${f.id} pelo filtro de ID ${f.filtro.id_filtro} com preço médio de ${f.filtro.avg}`);
          TopSniperUtil.salvarFiltroPiloto(this.urlUpdateFiltro, {
            id: f.id,
            id_filtro_copiar: f.filtro.id_filtro,
          });
        }
      });
    }

    private getCartasInteresseFiltrosPrincipais(topCartasMomento: ICartaTopSniper[] = this.topCartasMomento, quantidadeAmais: number = this.configuracoes.piloto.principal.quantidade_indicativa_que_a_carta_esta_caindo): ICartaTopSniper[] {
      return topCartasMomento.filter((ele: ICartaTopSniper) => {
        let naoConsiderarCartasDeValorAltoComPoucaQuantidade = !(ele.valor >= this.configuracoes.piloto.principal.desconsiderar_poucas_cartas_acima_de
          && ele.total < this.configuracoes.piloto.principal.quantidade_considero_poucas_cartas);

        return ele.quantidade_mais >= quantidadeAmais
          && ele.rareflag >= this.configuracoes.piloto.principal.raridade_minima_piloto_principal
          && ele.lucro_unitario && ele.lucro_unitario >= this.configuracoes.piloto.principal.lucro_unitario_minimo
          && ele.valor >= this.configuracoes.piloto.principal.preco_compra_carta_acima_de
          && ele.valor <= this.configuracoes.piloto.principal.valor_caixa_maximo
          && naoConsiderarCartasDeValorAltoComPoucaQuantidade;
      });
    }

    private getCartasInteresseFiltrosPrincipaisSobra(topCartasMomento: ICartaTopSniper[] = this.topCartasMomento): ICartaTopSniper[] {
      return topCartasMomento.filter((ele: ICartaTopSniper) => {
        return ele.quantidade_mais < this.configuracoes.piloto.principal.quantidade_indicativa_que_a_carta_esta_caindo
          && ele.total >= this.configuracoes.piloto.principal.quantidade_considero_poucas_cartas
          && ele.rareflag >= this.configuracoes.piloto.principal.raridade_minima_piloto_principal
          && ele.lucro_unitario && ele.lucro_unitario >= this.configuracoes.piloto.principal.lucro_unitario_minimo
          && ele.valor >= this.configuracoes.piloto.principal.preco_compra_carta_acima_de
          && ele.valor <= this.configuracoes.piloto.principal.valor_caixa_maximo;
      });
    }

    public async processarTopCartasPilotoPrincipalPorRaridade(cartasEspeciaisPilotoPlus: ICartaTopSniper[], cartasEspeciaisPilotoSobra: ICartaTopSniper[]) {
      if (cartasEspeciaisPilotoPlus.length) {
        TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_especial_piloto_a, cartasEspeciaisPilotoPlus[0], cartasEspeciaisPilotoPlus,
          this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
          this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
          this.urlUpdateFiltro);

        if (cartasEspeciaisPilotoPlus.length <= 1 && cartasEspeciaisPilotoSobra.length) {
          cartasEspeciaisPilotoPlus = cartasEspeciaisPilotoPlus.concat(cartasEspeciaisPilotoSobra);
        }

        if (cartasEspeciaisPilotoPlus.length > 1) {
          TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_especial_piloto_b, cartasEspeciaisPilotoPlus[1], cartasEspeciaisPilotoPlus,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }

        if (cartasEspeciaisPilotoPlus.length <= 2 && cartasEspeciaisPilotoSobra.length) {
          cartasEspeciaisPilotoPlus = cartasEspeciaisPilotoPlus.concat(cartasEspeciaisPilotoSobra);
        }

        if (cartasEspeciaisPilotoPlus.length > 2) {
          TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_especial_piloto_c, cartasEspeciaisPilotoPlus[2], cartasEspeciaisPilotoPlus,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }

        if (cartasEspeciaisPilotoPlus.length > 3) {
          TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_especial_piloto_d, cartasEspeciaisPilotoPlus[3], cartasEspeciaisPilotoPlus,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }
      }

      console.log("🔥PILOTO PRINCIPAL RARIDADES FINAL::", cartasEspeciaisPilotoPlus);

      // this.armazenarCartasPilotoPrincipal();
      // this.verificarESalvarCartasPrincipaisAcumuladas();
    }

    public async processarTopCartasPilotoPrincipalPorQualidade(cartasEspeciaisPilotoPlus: ICartaTopSniper[], cartasEspeciaisPilotoSobra: ICartaTopSniper[]) {
      if (cartasEspeciaisPilotoPlus.length) {
        TopSniperFernando.salvarFiltroFernandoPorQualidade(this.configuracoes.filtros.id_filtro_especial_piloto_a, cartasEspeciaisPilotoPlus[0], cartasEspeciaisPilotoPlus,
          this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
          this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
          this.urlUpdateFiltro);

        if (cartasEspeciaisPilotoPlus.length <= 1 && cartasEspeciaisPilotoSobra.length) {
          cartasEspeciaisPilotoPlus = cartasEspeciaisPilotoPlus.concat(cartasEspeciaisPilotoSobra);
        }

        if (cartasEspeciaisPilotoPlus.length > 1) {
          TopSniperFernando.salvarFiltroFernandoPorQualidade(this.configuracoes.filtros.id_filtro_especial_piloto_b, cartasEspeciaisPilotoPlus[1], cartasEspeciaisPilotoPlus,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }

        if (cartasEspeciaisPilotoPlus.length <= 2 && cartasEspeciaisPilotoSobra.length) {
          cartasEspeciaisPilotoPlus = cartasEspeciaisPilotoPlus.concat(cartasEspeciaisPilotoSobra);
        }

        if (cartasEspeciaisPilotoPlus.length > 2) {
          TopSniperFernando.salvarFiltroFernandoPorQualidade(this.configuracoes.filtros.id_filtro_especial_piloto_c, cartasEspeciaisPilotoPlus[2], cartasEspeciaisPilotoPlus,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }

        if (cartasEspeciaisPilotoPlus.length > 3) {
          TopSniperFernando.salvarFiltroFernandoPorQualidade(this.configuracoes.filtros.id_filtro_especial_piloto_d, cartasEspeciaisPilotoPlus[3], cartasEspeciaisPilotoPlus,
            this.configuracoes.piloto.principal.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.principal.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro);
        }
      }

      console.log("🔥PILOTO PRINCIPAL QUALIDADES FINAL::", cartasEspeciaisPilotoPlus, cartasEspeciaisPilotoSobra);

      // this.armazenarCartasPilotoPrincipal();
      // this.verificarESalvarCartasPrincipaisAcumuladas();
    }

    public async metodoTopCartasPilotoPrincipal() {
      let cartasEspeciaisPilotoPlus: ICartaTopSniper[] = this.getCartasInteresseFiltrosPrincipais()
      let cartasEspeciaisPilotoSobra: ICartaTopSniper[] = this.getCartasInteresseFiltrosPrincipaisSobra()
      let cartasQualidadeEspeciaisPilotoPlus: ICartaTopSniper[] = []
      let cartasQualidadeEspeciaisPilotoSobra: ICartaTopSniper[] = []

      console.log("🔥PILOTO PRINCIPAL::", cartasEspeciaisPilotoPlus,);
      console.log("🔥PILOTO SOBRA::", cartasEspeciaisPilotoSobra);

      if (this.configuracoes.usar_filtro_qualidade) {
        cartasQualidadeEspeciaisPilotoPlus = await TopSniperUtil.filtrarCartasQualidadeEspecialCompativelFiltro(cartasEspeciaisPilotoPlus)
        cartasQualidadeEspeciaisPilotoSobra = await TopSniperUtil.filtrarCartasQualidadeEspecialCompativelFiltro(cartasEspeciaisPilotoSobra)
      }

      console.log("🔥PILOTO QUALIDADE PRINCIPAL::", cartasQualidadeEspeciaisPilotoPlus.length, cartasEspeciaisPilotoPlus.length, cartasQualidadeEspeciaisPilotoPlus);
      console.log("🔥PILOTO QUALIDADE SOBRA::", cartasQualidadeEspeciaisPilotoSobra.length, cartasEspeciaisPilotoSobra.length, cartasQualidadeEspeciaisPilotoSobra);

      if (this.configuracoes.usar_filtro_qualidade) {
        this.processarTopCartasPilotoPrincipalPorQualidade(cartasQualidadeEspeciaisPilotoPlus, cartasQualidadeEspeciaisPilotoSobra)
      } else {
        this.processarTopCartasPilotoPrincipalPorRaridade(cartasEspeciaisPilotoPlus, cartasEspeciaisPilotoSobra)
      }
    }

    private getCartasInteresseFiltrosIniciais(topCartasMomento: ICartaTopSniper[] = this.topCartasMomento, quantidadeAmais: number = 1): ICartaTopSniper[] {
      return topCartasMomento.filter((ele: any) => {
        return ele.quantidade_mais >= quantidadeAmais
          && ele.lucro_unitario && ele.lucro_unitario >= this.configuracoes.piloto.inicial.lucro_unitario_minimo
          && ele.valor >= this.configuracoes.piloto.inicial.preco_compra_carta_acima_de
          && ele.valor <= this.configuracoes.piloto.inicial.valor_caixa_maximo;
      });
    }

    private metodoTopCartasOuroPilotoSecundarioInicial() {
      let cartasOuroPiloto = this.getCartasInteresseFiltrosIniciais()
      console.log("🏴 PILOTO INICIAL::", cartasOuroPiloto);

      // salvando até 4 filtros
      if (cartasOuroPiloto.length) {
        TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_inicial_A, cartasOuroPiloto[0], cartasOuroPiloto,
          this.configuracoes.piloto.inicial.lucro_unitario_minimo_cartas_relacionadas,
          this.configuracoes.piloto.inicial.total_cartas_relacionadas_incluir_no_filtro,
          this.urlUpdateFiltro
        );

        // if (cartasOuroPiloto.length > 1) {
        //   TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_inicial_B, cartasOuroPiloto[1], cartasOuroPiloto,
        //     this.configuracoes.piloto.inicial.lucro_unitario_minimo_cartas_relacionadas,
        //     this.configuracoes.piloto.inicial.total_cartas_relacionadas_incluir_no_filtro,
        //     this.urlUpdateFiltro
        //   );
        // }

        // if (cartasOuroPiloto.length > 2) {
        //   TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_inicial_C, cartasOuroPiloto[2], cartasOuroPiloto, this.configuracoes.piloto.inicial.lucro_unitario_minimo_cartas_relacionadas, this.urlUpdateFiltro);
        // }

        // if (cartasOuroPiloto.length > 3) {
        //   TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_inicial_D, cartasOuroPiloto[3], cartasOuroPiloto, this.configuracoes.piloto.inicial.lucro_unitario_minimo_cartas_relacionadas, this.urlUpdateFiltro);
        // }
      }

      console.log("🏴PILOTO INICIAL FINAL::", cartasOuroPiloto);
    }

    private armazenarCartasPilotoPrincipal(): void {
      let cartasArmazenadas = this.getCartasArmazenadas();

      // armazenando full das duas de mais lucro
      if (this.topCartasMomento.length) {
        cartasArmazenadas.push(this.topCartasMomento[0]);
        if (this.topCartasMomento.length > 1) {
          cartasArmazenadas.push(this.topCartasMomento[1]);
        }
      }

      localStorage.setItem(this.keyStorageCartasArmazenadas, JSON.stringify(cartasArmazenadas));
    }

    private getCartasArmazenadas(key: string = this.keyStorageCartasArmazenadas): ICartaTopSniper[] {
      return JSON.parse(localStorage.getItem(key) || '[]') as ICartaTopSniper[];
    }

    public estaNaHoraDeSalvarFiltroFull(agora: number): boolean {
      const ultimaVezSalvo = localStorage.getItem(this.keyStorageUltimaVezSalvoFiltroFull);
      const intervaloEmMilissegundos = this.intervaloEmMinutosStorageTempoAtualizacaoFiltroFull * 60 * 1000;

      return !ultimaVezSalvo || (agora - parseInt(ultimaVezSalvo, 10)) >= intervaloEmMilissegundos;
    }

    private verificarESalvarCartasPrincipaisAcumuladas(): void {
      const agora = Date.now();
      if (this.estaNaHoraDeSalvarFiltroFull(agora)) {
        this.salvarFiltroMaisFrequentePrincipal();
        localStorage.setItem(this.keyStorageUltimaVezSalvoFiltroFull, agora.toString());
      }
    }

    private encontrarCartaMaisFrequente(cartasArmazenadas: ICartaTopSniper[]): ICartaTopSniper {
      if (cartasArmazenadas.length === 0) {
        return null;
      }

      let contagemCartas: { [key: string]: number } = {};

      cartasArmazenadas.forEach((carta: any) => {
        if (contagemCartas[carta.resource_id]) {
          contagemCartas[carta.resource_id]++;
        } else {
          contagemCartas[carta.resource_id] = 1;
        }
      });

      let resourceIdMaisFrequente = Object.keys(contagemCartas).reduce((a, b) => contagemCartas[a] > contagemCartas[b] ? a : b);
      return (cartasArmazenadas as any).find((carta: ICartaTopSniper) => carta.resource_id.toString() === resourceIdMaisFrequente.toString());
    }

    private topCartasMaisFrequentes(cartasArmazenadas: ICartaTopSniper[]): ICartaTopSniper[] {
      if (cartasArmazenadas.length === 0) {
        return [];
      }

      let contagemCartas: { [key: string]: number } = {};

      // Contar a frequência de cada carta
      cartasArmazenadas.forEach((carta: ICartaTopSniper) => {
        if (contagemCartas[carta.resource_id]) {
          contagemCartas[carta.resource_id]++;
        } else {
          contagemCartas[carta.resource_id] = 1;
        }
      });

      // Ordenar as cartas pela frequência em ordem decrescente
      let cartasOrdenadas = Object.keys(contagemCartas)
        .sort((a, b) => contagemCartas[b] - contagemCartas[a])
        .slice(0, 6); // Selecionar as 6 cartas mais frequentes

      // Encontrar as cartas correspondentes aos IDs mais frequentes
      let cartasMaisFrequentes = cartasOrdenadas.map(resourceId =>
        (cartasArmazenadas as any).find((carta: ICartaTopSniper) => carta.resource_id.toString() === resourceId.toString())
      );

      return cartasMaisFrequentes.filter(carta => carta !== undefined) as ICartaTopSniper[];
    }

    private salvarFiltroMaisFrequentePrincipal(): void {
      let cartasArmazenadas = this.getCartasArmazenadas();
      if (cartasArmazenadas.length === 0) return;


      let todasCartaMaisFrequente: ICartaTopSniper = this.encontrarCartaMaisFrequente(cartasArmazenadas);
      let topCartaMaisFrequente: ICartaTopSniper[] = this.topCartasMaisFrequentes(cartasArmazenadas);

      let cartasPilotoInicialMaisFrequentes: ICartaTopSniper[] = this.getCartasInteresseFiltrosIniciais(topCartaMaisFrequente, 0)
      let cartasPilotoPrincipalMaisFrequentes: ICartaTopSniper[] = this.getCartasInteresseFiltrosPrincipais(topCartaMaisFrequente, 0)
      // da um merge nas duas listas cartasPilotoInicialMaisFrequentes e cartasPilotoPrincipalMaisFrequentes
      let topCartaMaisFrequentePilotoPrincipalEInicial = cartasPilotoInicialMaisFrequentes.concat(cartasPilotoPrincipalMaisFrequentes);

      // let topCartaMaisFrequenteAgrupadas = this.agruparPorRaridade(topCartaMaisFrequentePilotoPrincipalEInicial);

      console.log(`💎 SALVAR: CARTA FREQUENTE EM ${this.intervaloEmMinutosStorageTempoAtualizacaoFiltroFull}`);
      console.log('cartaMaisFrequente:', todasCartaMaisFrequente);
      console.log('topCartaMaisFrequente:', topCartaMaisFrequente);

      console.log('topCartaMaisFrequentePilotoPrincipalEInicial', topCartaMaisFrequentePilotoPrincipalEInicial);

      console.log('cartasPilotoInicialMaisFrequentes', cartasPilotoInicialMaisFrequentes);
      console.log('cartasPilotoPrincipalMaisFrequentes', cartasPilotoPrincipalMaisFrequentes);

      // console.log('topCartaMaisFrequenteAgrupadas', topCartaMaisFrequenteAgrupadas);

      if (topCartaMaisFrequentePilotoPrincipalEInicial.length) {
        TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_full_A, topCartaMaisFrequentePilotoPrincipalEInicial[0], topCartaMaisFrequentePilotoPrincipalEInicial,
          this.configuracoes.piloto.full.lucro_unitario_minimo_cartas_relacionadas,
          this.configuracoes.piloto.full.total_cartas_relacionadas_incluir_no_filtro, this.urlUpdateFiltro
        );
        if (topCartaMaisFrequentePilotoPrincipalEInicial.length > 1) {
          TopSniperFernando.salvarFiltroFernando(this.configuracoes.filtros.id_filtro_piloto_full_B, topCartaMaisFrequentePilotoPrincipalEInicial[1], topCartaMaisFrequentePilotoPrincipalEInicial,
            this.configuracoes.piloto.full.lucro_unitario_minimo_cartas_relacionadas,
            this.configuracoes.piloto.full.total_cartas_relacionadas_incluir_no_filtro,
            this.urlUpdateFiltro
          );
        }
      }
    }


    private getMelhoresFiltrosDeMomento(
      topFiltros: IObjetoTopFiltros[],
      topX = 3,
      opts: any = {}
    ) {
      const options = {
        excludeSuspiciousIds: true,
        suspiciousIds: new Set<number>([]), // ex: new Set([4294967295])

        minRegistros: 3,
        minPriceFloor: 10000,     // min >= 10k
        minRangeAbs: 15000,       // (max - min) >= 15k

        useRobustPercentiles: true,

        ...opts
      };

      const toNum = (v: any) => {
        const n = typeof v === "string" ? Number(v) : v;
        return Number.isFinite(n) ? n : NaN;
      };

      const parseList = (s: any) => {
        if (!s || typeof s !== "string") return [];
        return s
          .split(",")
          .map((x: string) => Number(x.trim()))
          .filter((n: number) => Number.isFinite(n));
      };

      const percentile = (sortedAsc: number[], p: number) => {
        if (!sortedAsc.length) return NaN;
        const idx = Math.floor((sortedAsc.length - 1) * p);
        return sortedAsc[idx];
      };

      const picked = (topFiltros || [])
        .map((f: any) => {
          const id_filtro = toNum(f.id_filtro);
          const total = toNum(f.total_registros);

          if (!Number.isFinite(id_filtro)) return null;
          if (!Number.isFinite(total) || total < options.minRegistros) return null;

          if (options.excludeSuspiciousIds && options.suspiciousIds.has(id_filtro)) {
            return null;
          }

          let min = toNum(f.menor_valor);
          let max = toNum(f.maior_valor);

          // robustez: usa p10/p90 se tiver lista de valores suficiente
          if (options.useRobustPercentiles) {
            const valoresArr = parseList(f.valores);
            if (valoresArr.length >= 5) {
              const sorted = [...valoresArr].sort((a, b) => a - b);
              const p10 = percentile(sorted, 0.10);
              const p90 = percentile(sorted, 0.90);
              if (Number.isFinite(p10)) min = p10;
              if (Number.isFinite(p90)) max = p90;
            }
          }

          if (!Number.isFinite(min) || !Number.isFinite(max) || min <= 0 || max <= 0 || max < min) return null;

          if (min < options.minPriceFloor) return null;

          const rangeAbs = max - min;
          if (rangeAbs < options.minRangeAbs) return null;

          return {
            ...f,
            id_filtro,
            total_registros: total,
            min,
            max,
            rangeAbs
          };
        })
        .filter(Boolean)
        // maior ocorrência primeiro; desempate: maior range; depois maior max
        .sort((a: any, b: any) =>
          (b.total_registros - a.total_registros) ||
          (b.rangeAbs - a.rangeAbs) ||
          (b.max - a.max)
        );

      return picked.slice(0, topX);
    }

  }
}
